export const MenuTheme = {
  parts: ['item'],
  baseStyle: {
    item: {
      _focus: {
        bg: 'green.50'
      }
    }
  }
};
